<template>
  <div
    :class="`owal potential match container ${first ? 'first' : ''}`"
  >
    <img
      :class="`owal potential match profile image ${match.is_exact ? 'exact' : 'potential'}`"
      :src="match.image_uri"
      @click="$emit(`click`)"
    >
    <owal-indicator-confidence
      :confidence="confidence"
      :confidenceThreshold="match.threshold"
    />
    <div
      class="owal potential match profile text container"
    >
      <router-link
        :to="'/faces/' + match.frontend_face_uuid"
        class="owal potential match profile text name"
      >
        {{ match.person_name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import OwalIndicatorConfidence from '@/libraries/owal-ui/indicators/OwalIndicatorConfidence'

export default {
  name: 'OwalTrainingToolCandidateProfileButton',
  components: {
    OwalIndicatorConfidence,
  },
  /**
   * @prop {Boolean} first Tells us if the face is the first match in the list.
   * @prop {Object} match An object with confidence information.
   */
  props: {
    first: {
      type: Boolean,
      default: false,
    },
    match: {
      type: Object,
    },
  },
  computed: {
    confidence () {
      if (!this.match.is_exact) {
        return (this.match.diff || this.match.confidence)
      }
      return 1
    },
  },
}
</script>

<style scoped>

/* The button wrapper. */
.owal.potential.match.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 0 0.65rem;
  padding: 0;
  cursor: pointer;
}

/* The profile image. */
.owal.potential.match.container .owal.potential.match.profile.image {
  height: 5.7142857143rem;
  width: 5.7142857143rem;
  border-radius: 2.8571428572rem;
  object-fit: cover;
  background: #EFF2F7;
  border: 2px solid #475669;
  transition: border-color 300ms ease, transform 300ms ease;
  z-index: 1;
  margin: 0 0 0.4rem 0;
}

/* Make first image larger. */
.owal.potential.match.container.first .owal.potential.match.profile.image {
  transform: scale(1.1);
}

/* --- Borders for the first image. --- */
.owal.potential.match.container.first .owal.potential.match.profile.image.exact {
  border: 4px solid #C0CCDA;
}

.owal.potential.match.container.first .owal.potential.match.profile.image.potential {
  border: 4px solid #475669;
}

/* --- Profile Hover Effects --- */

.owal.potential.match.container:hover {
  /* margin: 0.5rem 0.7rem; */
}

.owal.potential.match.container:hover .owal.potential.match.profile.image,
.owal.potential.match.container.first:hover .owal.potential.match.profile.image {
  border-color: #C0CCDA;
  transform: scale(1.2);
  z-index: 2;
}

/* --- Match Confidence Indicators --- */
.owal.potential.match.container >>> .owal.indicator.confidence {
  width: 5.7142857143rem;
  height: 1.7142857143rem;
  display: flex;
  flex-direction: row-reverse;
  margin-top: -2rem;
  transition: opacity 300ms ease, transform 300ms ease-in;
  transition-delay: 0, 50ms;
  z-index: 2;
}

.owal.potential.match.container:hover >>> .owal.indicator.confidence {
  transform: translateX(0.5rem) translateY(0.5rem);
}

/* Adjust match confidence indicators */
.owal.potential.match.container.first >>> .owal.indicator.confidence {
  transform: scale(1.1);
  margin-bottom: 1rem;
}

.owal.potential.match.container.first:hover >>> .owal.indicator.confidence {
  transform: scale(1.1) translateX(0.5rem) translateY(0.5rem);
}

.owal.potential.match.profile.text.container {
  align-self: flex-end;
}

/* --- Person Name --- */
.owal.potential.match.profile.text.container,
.owal.potential.match.profile.text.container a {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 5.7142857143rem;
}

.owal.potential.match.profile.text.container,
.owal.potential.match.profile.text.container a {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-family: 'Lato-Bold', sans-serif;
  font-size: 1rem;
  color: #475669;
  letter-spacing: 0;
  text-align: center;
}

.owal.potential.match.container.first .owal.potential.match.profile.text.container a:after {
  content: 'best match';
  font-family: 'Lato-Italic', sans-serif;
  font-size: 12px;
  color: #8492A6;
  letter-spacing: 0;
}

</style>
